import React from 'react';
import { Box, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';
import { normalizeOutOfTownDays, outOfTownChoiceLabel } from '../../utils/outOfTownSurcharge';

/**
 * @param {{ value: number, onChange: (days: number) => void, dayRate?: number, maxDays?: number, disabled?: boolean }} props
 */
export default function OutOfTownLocationPanel({ value, onChange, dayRate = 251, maxDays = 2, disabled = false }) {
  const days = normalizeOutOfTownDays(value, maxDays);
  const rate = Number(dayRate) >= 0 ? Number(dayRate) : 251;
  const max = Math.max(1, parseInt(maxDays, 10) || 2);

  const handleChange = (e) => {
    onChange(normalizeOutOfTownDays(e.target.value, max));
  };

  const options = [
    { days: 0, label: outOfTownChoiceLabel(0, rate) },
    ...Array.from({ length: max }, (_, i) => {
      const d = i + 1;
      return { days: d, label: outOfTownChoiceLabel(d, rate) };
    }),
  ];

  return (
    <Box
      sx={{
        mt: 1.25,
        p: 1.25,
        borderRadius: 2,
        bgcolor: '#fff7ed',
        border: '1px solid #fed7aa',
      }}
    >
      <Typography variant="subtitle2" sx={{ fontWeight: 800, color: '#5a2d0c', mb: 0.5 }}>
        Service location
      </Typography>
      <Typography variant="caption" sx={{ color: '#7c4a12', display: 'block', mb: 1 }}>
        Home visits outside Shelby County add ${rate.toFixed(0)} per day.
      </Typography>
      <RadioGroup
        row
        name="out-of-town-days"
        value={days}
        onChange={handleChange}
        sx={{
          flexWrap: 'nowrap',
          gap: { xs: 0.5, sm: 1.5 },
          mx: -0.5,
          overflowX: 'auto',
          pb: 0.25,
          '& .MuiFormControlLabel-root': {
            mr: 0,
            ml: 0,
            flexShrink: 0,
          },
          '& .MuiFormControlLabel-label': {
            fontSize: { xs: '0.72rem', sm: '0.8125rem' },
            fontWeight: 600,
            color: '#5a2d0c',
            lineHeight: 1.25,
          },
          '& .MuiRadio-root': {
            color: '#c4a574',
            p: 0.5,
            '&.Mui-checked': { color: '#e86400' },
          },
        }}
      >
        {options.map((opt) => (
          <FormControlLabel
            key={opt.days}
            value={opt.days}
            disabled={disabled}
            control={<Radio size="small" />}
            label={opt.label}
          />
        ))}
      </RadioGroup>
    </Box>
  );
};
